import { get, isEmpty } from 'lodash';
import _ from 'lodash';
import { UserPerm } from '@/types';

const hasOfficePermission = permissions =>
  permissions.includes(UserPerm.PERM_ADMIN) ||
  permissions.includes(UserPerm.PERM_OFFICE);

export const hasFinancialPermission = permissions =>
  permissions.includes(UserPerm.PERM_ADMIN) ||
  permissions.includes(UserPerm.PERM_FINANCIAL) ||
  permissions.includes(UserPerm.PERM_OFFICE);

const hasAdminPermission = permissions => permissions.includes(UserPerm.PERM_ADMIN);

const hasCreateListingPermission = permissions =>
  permissions.includes(UserPerm.PERM_CREATE_LISTING) ||
  permissions.includes(UserPerm.PERM_OFFICE) ||
  permissions.includes(UserPerm.PERM_ADMIN);

const hasCarrierDirectAssignPermission = permissions =>
  permissions.includes(UserPerm.PERM_LOAD_ASSIGN);

const hasDriverPermission = permissions => isEmpty(permissions);

const hasReceiverPermission = permissions =>
  permissions.includes(UserPerm.PERM_RECEIVING) ||
  permissions.includes(UserPerm.PERM_OFFICE) ||
  permissions.includes(UserPerm.PERM_ADMIN);

const findCompanyAccountPermissions = account =>
  get(account, 'companyPermissions', []);

// "composite" account permission resolutions (inherited permissions)
export const accountHasDriverPermission = (account) => {
  const permissions = findCompanyAccountPermissions(account);
  return hasDriverPermission(permissions);
};
export const accountHasOfficePermission = (account) => {
  const permissions = findCompanyAccountPermissions(account);
  return hasOfficePermission(permissions);
};


export const accountHasFinancialPermission = (account) => {
  const permissions = findCompanyAccountPermissions(account);
  return hasFinancialPermission(permissions);
};

export const accountHasAdminPermission = (account) => {
  const permissions = findCompanyAccountPermissions(account);
  return hasAdminPermission(permissions);
};

export const accountHasCarrierDirectAssignPermission = (account) => {
  const permissions = findCompanyAccountPermissions(account);
  return hasCarrierDirectAssignPermission(permissions);
};

export const accountHasCreateListingPermission = (account) => {
  const permissions = findCompanyAccountPermissions(account);
  return hasCreateListingPermission(permissions);
};

// "semantic" account permisison resolution (business rules)
export const canAccountViewCompanyListings = (account) => {
  const permissions = findCompanyAccountPermissions(account);

  return hasCreateListingPermission(permissions) ||
         hasReceiverPermission(permissions);
};

export const canAccountViewCompanyBookedLoads = (account) => {
  const permissions = findCompanyAccountPermissions(account);

  return hasReceiverPermission(permissions);
};

export const canAccountViewCompanyBids = (account) => {
  const permissions = findCompanyAccountPermissions(account);
  return hasFinancialPermission(permissions);
};

export const canAccountViewCompanyLoadSettlements = (account) => {
  const permissions = findCompanyAccountPermissions(account);
  return hasFinancialPermission(permissions) ||
         hasOfficePermission(permissions);
};

export const canAccountViewCompanyBookedLoadsHistory = (account) => {
  const permissions = findCompanyAccountPermissions(account);
  return hasFinancialPermission(permissions) ||
         hasOfficePermission(permissions);
};
/*
export const canAccountViewCompanyBookedLoads = (account) => {
  const permissions = findCompanyAccountPermissions(account);
  return hasReceiverPermission(permissions) ||
         hasCreateListingPermission(permissions) ||
         canAccountViewCompanyBookedLoadsHistory(account);
};
 */

export const canProfileViewLoad = (profile, loadId) => {
  const loads = get(profile, 'loadPermissions', []);
  const permissions = _.find(loads, { loadId });

  return permissions && permissions.includes(UserPerm.PERM_LINK_VISITOR);
};

export const canProfileDeliverLoad = (profile, loadId) => {
  const loads = get(profile, 'loadPermissions', []);
  const permissions = _.find(loads, { loadId });

  return permissions && permissions.permissions.includes(UserPerm.PERM_ASSIGNED_LOAD_HAULER);
};

export default {
  // accountHasCreateListing,
  //
  // canAccountViewCompanyListings,
  // canAccountViewCompanyBids,
  // canAccountViewCompanyBookedLoads,
  // canAccountViewCompanyBookedLoadsHistory,
};



// WEBPACK FOOTER //
// ./src/store/permissions.js